import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ThreeDimensionalOutlineSVG = function ThreeDimensionalOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 8L17 1.6a1.8 1.8 0 00-1-.2 1.8 1.8 0 00-1 .2L4 8a1.9 1.9 0 00-1 1.7v11.7a2 2 0 00.9 1.7l11 7.2h.1l1 .2 1-.2h.1l11-7.2a2 2 0 00.9-1.7V9.7A1.9 1.9 0 0028 8zM15 28L5 21.4V10.8l10 5.8zm1-13.1L6 9.1l10-5.7 10 5.7zm11 6.5L17 28V16.6l10-5.8z"
  }));
};
ThreeDimensionalOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ThreeDimensionalOutlineSVG);